export default {"src":"/_next/static/media/swipe-right.a4b84b7d.svg","height":18,"width":10};